import { render, staticRenderFns } from "./Y02B.vue?vue&type=template&id=08367e46&scoped=true"
import script from "./Y02B.vue?vue&type=script&lang=js"
export * from "./Y02B.vue?vue&type=script&lang=js"
import style0 from "./Y02B.vue?vue&type=style&index=0&id=08367e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08367e46",
  null
  
)

export default component.exports